import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setModalVisible, setCheckData } from "features/planning/planningSlice";
import { fetchThingDetails } from "features/thing/thingThunk";
import axios from "axios";

export default function AssignReplacementDialog({ onAssign }) {
  const [selectedReplacement, setSelectedReplacement] = useState(null);
  const [confirmMode, setConfirmMode] = useState(false);
  const dispatch = useDispatch();
  const things = useSelector((state) => state.things.things);
  const modalVisible = useSelector((state) => state.planning.modalVisible);
  const modalThingId = useSelector((state) => state.planning.modalThingId);
  const checkData = useSelector((state) => state.planning.checkData);
  const isAssignReplacement = useSelector((state)=>state.planning.isAssignReplacement)
   
  // useEffect(() => {
  //   dispatch(fetchThingDetails());
  // }, [dispatch]);

  useEffect(() => {
  if (modalVisible) {
    dispatch(fetchThingDetails());
  }
}, [modalVisible, dispatch]);

  const handleAssignClick = () => {
    if (!selectedReplacement || !modalThingId) return;
    setConfirmMode(true);
  };
  // console.log(selectedReplacement, "selected Replacement ");

  const handleConfirm = async () => {
    try {
      const token = localStorage.getItem("token");

      if (checkData) {
        // REMOVE replacement
        const response = await axios.post(
          "https://v3.dhundhoo.com/thing/removeTempThing",
          {
            currentThingId: modalThingId.thingId,
            tempThingId: modalThingId?.tempThing,
          },
          {
            headers: { "x-dhundhoo-session": token },
          }
        );
        console.log("Remove response:", response.data);
        dispatch(fetchThingDetails())
        dispatch(setCheckData(false));
        setSelectedReplacement(null);
        setConfirmMode(false);
        dispatch(setModalVisible(false));
        
      } else {
        // ASSIGN replacement
        const response = await axios.post(
          "https://v3.dhundhoo.com/thing/assignTempThing",
          {
            currentThingId: modalThingId.thingId,
            tempThingId:selectedReplacement.thingId ,
          },
          {
            headers: { "x-dhundhoo-session": token },
          }
        );

        console.log("Assign response:", response.data);
        onAssign?.(selectedReplacement);
         dispatch(fetchThingDetails())
        setSelectedReplacement(null);
        setConfirmMode(false);
        dispatch(setModalVisible(false));
        dispatch(setCheckData(true));
      }
    } catch (error) {
      console.error("Error assigning/removing replacement:", error);
    }
  };

  const handleClose = () => {
    setSelectedReplacement(null);
    setConfirmMode(false);
    dispatch(setModalVisible(false));
  };

  return (
    <Dialog open={modalVisible} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {checkData
          ? "Remove Replacement Vehicle"
          : "Assign Replacement Vehicle"}
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <TextField
          fullWidth
          margin="normal"
          label="* Current Vehicle"
          value={
            modalThingId
              ? `${modalThingId.thingId} - ${modalThingId.nickName}`
              : ""
          }
          InputProps={{ readOnly: true }}
        />

        {/* Show Autocomplete only if assigning */}
        {!checkData && !confirmMode && (
          <Autocomplete
            options={(things || []).filter(
              (t) => t.thingId !== modalThingId?.thingId
            )}
            getOptionLabel={(option) => `${option.thingId}`}
            value={selectedReplacement}
            onChange={(e, newValue) => setSelectedReplacement(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                label="* Replacement Vehicle"
                placeholder="Select the vehicle"
                sx={{
                  padding: 0,
                  "& .MuiInputBase-root": { padding: 0 },
                }}
              />
            )}
          />
        )}

        {/* Confirm message for assign */}
        {confirmMode && selectedReplacement && !checkData && (
          <Typography sx={{ mt: 2 }}>
            You are assigning replacement vehicle{" "}
            <strong>{selectedReplacement.thingId}</strong> to vehicle{" "}
            <strong>{modalThingId.thingId}</strong>. Do you want to continue?
          </Typography>
        )}

        {/* Confirm message for remove */}
        {checkData && (
          <Typography sx={{ mt: 2 }}>
            A replacement vehicle is already assigned. Do you want to remove it?
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>

        {!checkData ? (
          !confirmMode ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleAssignClick}
              disabled={!selectedReplacement}
            >
              Assign
            </Button>
          ) : (
            <Button variant="contained" color="primary" onClick={handleConfirm}>
              Continue
            </Button>
          )
        ) : (
          <Button variant="contained" color="error" onClick={handleConfirm}>
            Remove
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
